import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@mezzoforte/forge';
import { formatCurrency } from '@/util/currency';

interface BidSuggestionModalProps {
  confirmedBid: number;
  minBid: number;
  onBid: () => void;
  onClose: () => void;
  isOpen?: boolean;
}

export function BidSuggestionModal({ confirmedBid, minBid, onBid, onClose, isOpen = false }: BidSuggestionModalProps) {
  return (
    <Modal
      verticalFooterButtons="sm"
      headerDivider
      isOpen={isOpen}
      onDismiss={onClose}
    >
      <ModalHeader>Tarjouksesi on liian matala</ModalHeader>
      <ModalBody>
        <Text>
          Tarjouksesi {formatCurrency(confirmedBid)} on matalampi kuin tämänhetkinen minimitarjous{' '}
          {formatCurrency(minBid)}. Haluatko korottaa kohteen tarjousta minimikorotuksen verran (
          {formatCurrency(minBid - confirmedBid)})?
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Peruuta</Button>
        <Button
          onClick={onBid}
          variant="primary"
        >
          Jätä tarjous {formatCurrency(minBid)}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
